<mat-card class="stats-card">
    <mat-card-content class="stats-card-content d-flex justify-content-between align-items-center p-3">
        <div class="stats-info">
            <div class="d-flex justify-content-between align-items-center">
                <span class="mb-1 fs-14 label-card">{{ label }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center">
                <span class="mb-0 fs-16 card-value">{{ value }}</span>
            </div>
        </div>
        <div class="stats-icon" [ngClass]="[color, customClass]">
            <mat-icon class="material-symbols-outlined">{{ icon }}</mat-icon>
        </div>
    </mat-card-content>
</mat-card>
